import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from "../../../../components/ui/card";
import { Button } from "../../../../components/ui/button";
import Table3 from "../../../../components/table/table-3";
import { useEffect, useState } from "react";

import { useGetAllRoles } from "../../../../hook/admin/use-role";
import {
  getAllPermissions,
  getRolePermissionById,
  grantRolePermission,
} from "../../../../services/admin/role-service";
import { showErrorToast, showSuccessToast } from "../../../../utils/toast-utils";
import Loader from "../../../../components/loader/loader";
import { Check, Key, KeyRoundIcon, X } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import Table2 from "../../../../components/table/table-2";
import ViewRolePermissionData from "../../../../components/viewsModals/viewRolePermissionDataById";
const AllPermission = () => {
  const [data, setData] = useState([
    { module: "dashboard", allow: false },
    { module: "system", allow: false },
  ]);
  const { data: roles = [], isLoading: rolesLoading } = useGetAllRoles();
  const [selectedRole, setSelectedRole] = useState(null);
  const [grantPermissionData, setGrantPermissionData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [closeMessage, setCloseMessage] = useState(false);
  const [viewPermissionDataById, setViewPermissionDataById] = useState(null);
  const [permissionLoading, setPermissionLoading] = useState(false);

  const permissionColumns = [
    { label: "Role Name", key: "roleName" },
    { label: "Role ID", key: "roleId" },

    {
      label: "Dashboard Access",
      key: "dashboard",
      render: (row) => (
        <span
          className={`px-2 py-1 rounded-full text-xs font-medium ${
            row.dashboard === 1
              ? "bg-green-100 text-green-700"
              : "bg-red-100 text-red-700"
          }`}
        >
          {row.dashboard === 1 ? "Allowed" : "Denied"}
        </span>
      ),
    },

    {
      label: "System Access",
      key: "system",
      render: (row) => (
        <span
          className={`px-2 py-1 rounded-full text-xs font-medium ${
            row.system === 1
              ? "bg-green-100 text-green-700"
              : "bg-red-100 text-red-700"
          }`}
        >
          {row.system === 1 ? "Allowed" : "Denied"}
        </span>
      ),
    },

    {
      label: "Status",
      key: "isActive",
      render: (row) => (
        <span
          className={`px-2 py-1 rounded-full text-xs font-medium ${
            row.isActive === 1
              ? "bg-green-100 text-green-700"
              : "bg-red-100 text-red-700"
          }`}
        >
          {row.isActive === 1 ? "Active" : "Inactive"}
        </span>
      ),
    },

    {
      label: "Actions",
      key: "actions",
      render: (row) => (
        <div className="flex gap-2">
          <button
            onClick={() => handleView(row.roleId)}
            className="px-2 py-1 text-xs bg-blue-100 text-blue-600 rounded hover:bg-blue-200"
          >
            View
          </button>
        </div>
      ),
    },

    {
      label: "Created",
      key: "created_at",
      render: (row) => new Date(row.created_at).toLocaleDateString(),
    },

    {
      label: "Updated",
      key: "updated_at",
      render: (row) => new Date(row.updated_at).toLocaleDateString(),
    },
  ];

  const handleView = async (id) => {
    if (!id) return;

    getPermissionById(id);
  };

  const handleCheckboxChange = (module) => {
    setData((prev) =>
      prev.map((item) =>
        item.module === module ? { ...item, allow: !item.allow } : item,
      ),
    );
  };

  const mapPermissionsToTable = (permissionData) => {
    return Object.entries(permissionData)
      .filter(
        ([key]) =>
          ![
            "id",
            "roleId",
            "roleName",
            "isActive",
            "deactivatedAt",
            "created_at",
            "updated_at",
          ].includes(key),
      )
      .map(([key, value]) => ({
        module: key,
        allow: value === 1,
      }));
  };

  const getPermissionById = async (id, type) => {
    setPermissionLoading(true);

    setData([
      { module: "dashboard", allow: false },
      { module: "system", allow: false },
    ]);

    const res = await getRolePermissionById({ role_id: id });

    if (res?.data?.status !== 200) {
      setPermissionLoading(false);
      throw new Error("Failed to fetch permissions");
    }

    const permissionData = res.data.data;

    if (type === "getId") {
      const formatted = mapPermissionsToTable(permissionData);
      setData(formatted);
      setPermissionLoading(false);
      console.log("formatted data", formatted);

      return permissionData;
    } else {
      setViewPermissionDataById(permissionData);
      setPermissionLoading(false);
    }
  };

  const {
    data: dataContainsPermissionId,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["role-permission", selectedRole?.id],
    queryFn: () => getPermissionById(selectedRole.id, "getId"),
    enabled: !!selectedRole?.id,
    retry: false,
  });

  const {
    data: allPermissionData,
    isLoading: allPermissionLoading,
    error: allPermissionError,
  } = useQuery({
    queryKey: ["all-permission", selectedRole?.id],
    queryFn: async () => await getAllPermissions(),
  });

  const permissionId = dataContainsPermissionId?.id;

  const handlePermission = async () => {
    const obj = Object.fromEntries(
      data.map((item) => [item.module, item.allow]),
    );

    setLoading(true);
    console.log("obj", obj);

    try {
      const res = await grantRolePermission({
        id: permissionId || selectedRole?.id,
        dashboard: obj.dashboard,
        system: obj.system,
      });
      if (res?.data?.status === 200) {
        setGrantPermissionData(res?.data);
        showSuccessToast(res.data?.message);
      } else {
        showErrorToast(
          res?.message || res?.data?.message || res?.data?.data?.message,
        );
        console.log(res);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
    console.log(obj);
  };

  useEffect(() => {
    console.log(viewPermissionDataById);
  }, [viewPermissionDataById]);

  useEffect(() => {
    console.log("selected role", selectedRole);
  }, [selectedRole]);
  return (
    <div className="p-2">
      {(loading || permissionLoading || allPermissionLoading) && <Loader />}
      <h2 className="text-2xl md:text-3xl text-gray-900 font-semibold mb-4 ">
       All Permission
      </h2>
      <div className="grid grid-cols-1 gap-6">
        <Card className="border-none shadow-md bg-white ">
          <div className="w-full p-6">
            <div className="flex flex-col gap-2 mt-2">
              <div>
                <label className="font-semibold text-gray-700">
                  Select Role
                </label>
              </div>
              <div>
                <select
                  value={selectedRole?.id}
                  onChange={(e) => {
                    const selected = roles.find(
                      (role) => role.id === e.target.value,
                    );
                    setSelectedRole(selected);
                  }}
                  className="border rounded p-2 w-full text-sm "
                >
                  <option value="">Select Role</option>
                  {!rolesLoading &&
                    roles.map((role) => (
                      <option key={role?.id} value={role?.id}>
                        {role?.roleName}
                      </option>
                    ))}{" "}
                </select>
              </div>
            </div>
          </div>
        </Card>

        {selectedRole?.roleName && (
          <Card className="rounded-xl border-none bg-white p-3">
            <CardHeader>
              <CardTitle className="text-md md:text-xl gap-2 text-gray-600 flex items-end">
                <Key />
                Module Permissions for{" "}
                <span className="text-3xl font-bold ml-2 text-blue-600">
                  {" "}
                  {selectedRole.roleName.charAt(0).toUpperCase() +
                    selectedRole.roleName.slice(1)}
                </span>
              </CardTitle>
            </CardHeader>
            <CardContent className="pl-4 text-[#081a3a] text-2xl  font-bold">
              <table className="min-w-full border border-gray-200 rounded-lg overflow-hidden">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                      Module
                    </th>
                    <th className="px-4 py-3 text-center text-sm font-semibold text-gray-600">
                      Allow
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {data.map((item) => (
                    <tr key={item.module} className="border-t">
                      <td className="px-4 py-3 text-gray-700 capitalize">
                        {item.module}
                      </td>

                      <td className="px-4 py-3 text-center">
                        <input
                          type="checkbox"
                          checked={item.allow}
                          onChange={() => handleCheckboxChange(item.module)}
                          className="w-5 h-5 accent-blue-600 cursor-pointer"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </CardContent>
            <CardContent>
              <Button onClick={handlePermission} variant="admin.secondary">
                Save Permissions
              </Button>
            </CardContent>
          </Card>
        )}
      </div>

      {!closeMessage && grantPermissionData?.status === 200 && (
        <div className="mt-4 flex items-center justify-between gap-3 rounded-xl border border-green-200 bg-green-50 px-4 py-3 shadow-sm animate-fade-in">
          <div className="flex justify-center items-center gap-4">
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-green-100">
              <Check className="h-5 w-5 text-green-600" />
            </div>

            <div className="flex flex-col">
              <p className="text-sm font-semibold text-green-700">Success</p>
              <p className="text-sm text-green-600">
                {grantPermissionData?.message ||
                  grantPermissionData?.data?.message ||
                  "Role updated successfully"}
              </p>
            </div>
          </div>

          <button onClick={() => setCloseMessage(true)} className="">
            <X />
          </button>
        </div>
      )}

      {viewPermissionDataById && (
        <ViewRolePermissionData
          rolePermissionData={viewPermissionDataById}
          setRolePermission={setViewPermissionDataById}
        />
      )}

      <Card className="rounded-xl border-none mt-4 bg-white ">
        <CardHeader>
          <CardTitle className="text-md md:text-xl text-gray-600">
            All Roles
          </CardTitle>
        </CardHeader>
        <CardContent className="pl-4 text-[#081a3a] text-2xl md:text-4xl font-bold">
          <Table2
            headerBg="bg-[#0A1F44]"
            columns={permissionColumns}
            data={allPermissionData?.data?.data}
            rowsPerPage={4}
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default AllPermission;
